import { toast } from 'react-hot-toast';
import { DefaultTheme } from 'styled-components';

/**
 * Helper para notificação de erro padronizada
 */
export const showErrorToast = (message: string, theme: DefaultTheme) => {
  toast.error(message, {
    style: {
      background: theme.colors.backgroundSecondary,
      color: theme.colors.textPrimary,
      border: `1px solid ${theme.colors.error}`,
      borderRadius: theme.borders.radius.lg,
      boxShadow: theme.shadows.lg,
    },
    iconTheme: {
      primary: theme.colors.error,
      secondary: theme.colors.backgroundSecondary,
    },
  });
};

/**
 * Helper para notificação de sucesso padronizada
 */
export const showSuccessToast = (message: string, theme: DefaultTheme) => {
  toast.success(message, {
    style: {
      background: theme.colors.backgroundSecondary,
      color: theme.colors.textPrimary,
      border: `1px solid ${theme.colors.error}`,
      borderRadius: theme.borders.radius.lg,
      boxShadow: theme.shadows.lg,
    },
    iconTheme: {
      primary: theme.colors.error,
      secondary: theme.colors.backgroundSecondary,
    },
  });
};

/**
 * Helper para notificação de info padronizada
 */
export const showInfoToast = (message: string, theme: DefaultTheme) => {
  toast.success(message, {
    style: {
      background: theme.colors.backgroundSecondary,
      color: theme.colors.textPrimary,
      border: `1px solid ${theme.colors.error}`,
      borderRadius: theme.borders.radius.lg,
      boxShadow: theme.shadows.lg,
    },
    iconTheme: {
      primary: theme.colors.error,
      secondary: theme.colors.backgroundSecondary,
    },
  });
};